<template>
  <section class="pt-20 pb-10 relative">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
      style="height: 80px; transform: translateZ(0px);"
    >
      <angled-s-v-g colorClass="text-white"></angled-s-v-g>
    </div>
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-center text-center mb-24">
        <div class="w-full lg:w-6/12 px-4">
          <h2 class="text-4xl font-semibold">xpera GmbH</h2>
          <p
            class="text-lg leading-relaxed m-4 text-gray-600"
          >Wir sind ein innovativer Zentralschweizer IT Dienstleister und helfen Ihnen bei der Umsetzung Ihres Digitalisierungsprojektes.</p>
        </div>
      </div>
      <div class="flex flex-wrap justify-center items-center text-center mb-24">
        <div class="w-full px-6 pb-6">
          <h2 class="text-4xl font-semibold">Referenzen</h2>
        </div>
        <div class="w-7/12  sm:w-6/12 md:w-6/12 lg:w-3/12 px-4">
          <a href="https://www.victorinox.com" target="_blank"><img src="../assets/img/victorinox.svg" alt="Victorinox AG" /></a>
        </div>
        <div class="w-6/12 sm:w-7/12 md:w-6/12 lg:w-3/12 px-4">
          <a href="https://impact-software.ch" target="_blank"><img src="../assets/img/impact.svg" alt="Impact Software AG" /></a>
        </div>
        <div class="w-8/12 sm:w-8/12 md:w-6/12 lg:w-3/12 px-4">
          <a href="https://www.adeco.ch" target="_blank"><img src="../assets/img/adeco.svg" alt="adeco AG" /></a>
        </div>
        <div class="w-4/12 sm:w-4/12 md:w-4/12 lg:w-2/12 px-4">
          <a href="https://www.moosfrei.ch/mymoosfrei" target="_blank"><img
            src="../assets/img/moosfrei.jpg"
            style="background-color: darkgrey;"
            alt="Moosfrei GmbH"
          /></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AngledSVG from "../components/Base/AngledSVG.vue";
export default {
  components: {
    AngledSVG
  }
};
</script>

<style>
</style>